import { AuthenticationController } from '@/components/auth/authentication-controller';

export function Signup() {
  return <AuthenticationController defaultView="signup" />;
}
